import React from 'react';
import {
    Page,
    TextField,
    Layout,
    Card,
    Checkbox,
    Select,
    FormLayout,
    Button,
    Thumbnail,
    Stack,
    TextStyle,
    Spinner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../common/Helpers';
import SelectProductsModal from "../../../components/SelectProductsModal"
import { ToGenieTag } from "../../../components/GenieTag";
import { Helmet } from 'react-helmet';

class AutoTagProductByTypePageComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            name: "",
            prefix: null,
            casingTransformation: "KeepOriginal",
            spacesTransformation: "KeepSpaces",
            trigger: "Automatic",
            modalActive: false,
            products: [],
            selectedProducts: [],
            productPreviews: [],
            loadingPreview: false,
        };

        if (props.rule != null) {
            this.state.name = props.rule.name;
            this.state.trigger = props.rule.trigger;
            this.state.prefix = props.rule.prefix;
            this.state.casingTransformation = props.rule.casingTransformation;
            this.state.spacesTransformation = props.rule.spacesTransformation;
            this.state.trigger = props.rule.trigger;
        };

        this.previewTimer = null;
    }

    renderPreviewArea = () => {

        if (this.state.loadingPreview) {
            return <Card.Section><Spinner size="large" /></Card.Section>
        }

        var previewProductItems = this.state.selectedProducts.map(_ => this.renderPreviewProduct(_));

        return previewProductItems;
    }

    renderPreviewProduct = (product) => {

        const preview = this.state.productPreviews.filter(_ => _.id === product.id)[0];
        let tags = null;

        if (preview != null) {

            tags = ToGenieTag(preview.tags);
        }

        return <Card.Section>
            <Stack alignment='center'>
                <Stack.Item>
                    <Thumbnail source={product.image} alt="image" size="small" />
                </Stack.Item>
                <Stack.Item>
                    <TextStyle variation="strong">{product.title}</TextStyle>
                </Stack.Item>
            </Stack>
            <br />
            <Stack spacing="tight" distribution="leading" alignment="leading">
                {tags}
            </Stack>
        </Card.Section >
    }

    render() {

        var hasName = this.state.name != null && this.state.name !== "";
        var canSave = hasName;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tag Rules - Product Vendor Rule</title>
                </Helmet>
                <Page
                    title={this.props.title}
                    primaryAction={{ content: this.props.actionTitle, onAction: this.handleSave, disabled: !canSave }}
                    breadcrumbs={[{ content: 'Tag Rules', url: '/tag-rules' }]}
                >
                    {this.state.modalActive && <SelectProductsModal
                        active={this.state.modalActive}
                        onCancel={this.onModalCancel}
                        onDone={this.onModalDone}
                        onQueryProducts={this.onQueryProducts}
                        selectedProducts={this.state.selectedProducts}
                        products={this.state.products}
                    />}
                    <Layout fullWidth>
                        <Layout.Section oneHalf>
                            <Card>
                                <Card.Section>
                                    <p>Auto tag product by ther vendor name.</p>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <TextField
                                            label="Rule Name"
                                            placeholder="Rule name"
                                            helpText={
                                                <span>
                                                    Give a name to easily identify this custom product rule.
                                                </span>
                                            }
                                            value={this.state.name}
                                            error={hasName ? null : "Must have name"}
                                            onChange={this.handleNameChange}
                                            autoComplete="off"
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <TextField
                                            value={this.state.prefix}
                                            label="Prefix"
                                            placeholder="(Optional) Leave blank if you do not want any prefixes"
                                            onChange={this.onPrefixChange}
                                            helpText={
                                                <span>
                                                    Prepend each tag with the prefix value.
                                                </span>
                                            }
                                        />
                                        <Select
                                            label="Casing Transformation"
                                            options={[
                                                { label: 'None - use original value', value: 'KeepOriginal' },
                                                { label: 'Upper case - uppercase for all letters', value: 'UpperCase' },
                                                { label: 'Lower case - lower case for all letters', value: 'LowerCase' },
                                                { label: 'Sentence case - lower case for all letters', value: 'SentenceCase' },
                                            ]}
                                            onChange={this.onCasingTransformationChange}
                                            value={this.state.casingTransformation}
                                            helpText={
                                                <span>
                                                    Keep using the original casing or transform it to upper case, lower case or sentence case.
                                                </span>
                                            }
                                        />
                                        <Select
                                            label="Spacing Transformation"
                                            options={[
                                                { label: 'Keep spaces', value: 'KeepSpaces' },
                                                { label: 'Use underscores - replace spaces with underscore', value: 'ReplaceWithUnderscores' },
                                                { label: 'Use hyphens - replace spaces with hypens', value: 'ReplaceWithHyphens' },
                                            ]}
                                            onChange={this.onSpacesTransformationChange}
                                            value={this.state.spacesTransformation}
                                            helpText={
                                                <span>
                                                    Replace spaces with underscores or keep spaces.
                                                </span>
                                            }
                                        />
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <Select
                                            label="Trigger"
                                            options={[
                                                { label: 'Manual - rule will be executed manually', value: 'Manual' },
                                                { label: 'Automatic - rule will be triggered when resources are updated/created', value: 'Automatic' }
                                            ]}
                                            onChange={this.onTriggerChange}
                                            value={this.state.trigger}
                                            helpText={
                                                <span>
                                                    Choose when rule will be triggered.
                                                </span>
                                            }
                                        />
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                            <Card sectioned title="Filter" subdued>
                                <p>Comming soon...</p>
                                <Checkbox
                                    label="Enable filtering"
                                    checked={false}
                                    disabled={true}
                                />
                            </Card>
                        </Layout.Section>
                        <Layout.Section oneThird>
                            <Card title="Preview" actions={[
                                { content: 'Clear', onAction: this.onClearPreview },
                                { content: 'Refresh', onAction: this.onRefreshPreview }
                            ]}>
                                <Card.Section>
                                    <p>Select at least one product to preview how rule might affect tags.</p>
                                    <br />
                                    <Button onClick={this.handleSelectTags}>Select Products</Button>
                                </Card.Section>
                                {this.renderPreviewArea()}
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    onQueryProducts = (searchString) => {

        fetch(`api/products/matching?queryString=${searchString}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                products: data,
            }));
    }

    handleSelectTags = () => {
        this.setState({
            modalActive: true
        });
    }

    onTriggerChange = (newValue) => {
        this.setState({
            trigger: newValue
        });
    }

    onModalCancel = () => {
        this.setState({
            modalActive: false
        });
    }

    onModalDone = (selectedProducts) => {
        this.setState({
            modalActive: false,
            selectedProducts: selectedProducts
        }, () => this.loadPreview());
    }

    handleNameChange = (value) => {
        this.setState({ name: value });
    }

    onCasingTransformationChange = (newValue) => {
        this.setState({
            casingTransformation: newValue
        }, () => this.requestPreview());
    }

    onSpacesTransformationChange = (newValue) => {
        this.setState({
            spacesTransformation: newValue
        }, () => this.requestPreview());
    }

    onPrefixChange = (newValue) => {
        this.setState({
            prefix: newValue
        }, () => this.requestPreview());
    }

    handleSave = () => {

        this.props.onAction({
            name: this.state.name,
            prefix: this.state.prefix,
            casingTransformation: this.state.casingTransformation,
            spacesTransformation: this.state.spacesTransformation,
            trigger: this.state.trigger,
        })
    }

    onClearPreview = () => {
        this.setState({
            selectedProducts: []
        })
    }

    onRefreshPreview = () => {
        this.requestPreview();
    }

    requestPreview = () => {
        if (this.state.selectedProducts.length === 0) {
            return;
        }

        if (this.previewTimer != null) {
            clearTimeout(this.previewTimer);
        }

        this.previewTimer = setTimeout(() => this.loadPreview(), 1000);
    }

    loadPreview = () => {

        this.previewTimer = null;

        if (this.state.selectedProducts.length === 0) {
            return;
        }

        this.setState({
            loadingPreview: true
        });

        const preview = {
            prefix: this.state.prefix,
            casingTransformation: this.state.casingTransformation,
            spacesTransformation: this.state.spacesTransformation,
            previewProductIds: this.state.selectedProducts.map(_ => _.id),
        };

        let body = JSON.stringify({ ...preview });

        fetch(`api/tagRules/AutoTagProductByType/preview`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: body
        }).then(response => response.json())
            .then(data => this.setState({
                productPreviews: data,
                loadingPreview: false
            }));
    }

    componentDidMount() {
    }
}

export default AutoTagProductByTypePageComponent;